/** Capitalize the first letter of a string (MUI-compatible utility). */
export const capitalize = (s: string): string => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s)
